import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import useWindowScrollYBetween from 'lib/hooks/useWindowScrollYBetween'

import './background.pcss'

const Background = ({ imagePath, blurHeight, positionY }) => {
    const isBlurred = useWindowScrollYBetween(blurHeight)

    return (
        <div className="background-wrapper">
            <div
                className="background"
                style={{
                    backgroundImage: `url(${imagePath})`,
                    backgroundPositionY: positionY || null
                }}
            >
            </div>
            {blurHeight && (
                <div
                    className={classNames(
                        'background-blurred',
                        { 'background-blurred--show': isBlurred },
                    )}
                    style={{
                        backgroundImage: `url(${imagePath})`,
                        backgroundPositionY: positionY || null
                    }}
                />
            )}
        </div>
    )
}

Background.propTypes = {
    imagePath: PropTypes.string,
    blurHeight: PropTypes.number,
    positionY: PropTypes.string,
}

export default Background
